"use strict";
import React from "react";
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("span", { className: "load_tms_deleted_warning_icon" }, /* @__PURE__ */ React.createElement("a", { href: "#" }, /* @__PURE__ */ React.createElement("span", { "data-tooltip": true, "aria-haspopup": "true", title: "Removed from TMS" }, /* @__PURE__ */ React.createElement("i", { className: "fi-alert" }))));
  }
});
